
namespace RioERP.Invoices {

    @Serenity.Decorators.registerClass()
    export class InvoiceOrdersGrid extends Serenity.EntityGrid<InvoiceOrdersRow, any> {
        protected getColumnsKey() { return InvoiceOrdersColumns.columnsKey; }
        protected getDialogType() { return InvoiceOrdersDialog; }
        protected getIdProperty() { return InvoiceOrdersRow.idProperty; }
        protected getInsertPermission() { return InvoiceOrdersRow.insertPermission; }
        protected getLocalTextPrefix() { return InvoiceOrdersRow.localTextPrefix; }
        protected getService() { return InvoiceOrdersService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected addButtonClick() {
            this.editItem({ InvoiceId: this.InvoiceId });
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.InvoiceId != null;
        }

        private _InvoiceId: number;

        get InvoiceId() {
            return this._InvoiceId;
        }

        set InvoiceId(value: number) {
            //debugger;
            if (this._InvoiceId != value) {
                this._InvoiceId = value;
                this.setEquality(InvoiceOrdersRow.Fields.InvoiceId, value);
                this.refresh();
            }
        }
    }
}